export const steps = [
  { label: "Job Summary", value: "forRevision" },
  { label: "Approved", value: "approved" },
  { label: "Scheduled", value: "scheduled" },
  { label: "In Progress", value: "inProgress" },
  { label: "Completed", value: "completed" },
];